import React, {useEffect, useState} from 'react';
import {Button, Container, Input, Text} from '../../components/@FreeModel';
import {useNavigate, useParams} from 'react-router-dom';
import Header from '../../components/general/Header/Header';
import {gql, queryApplication, updateApplication} from "../../db/model";
import {useDispatch, useSelector} from "react-redux";
import {selectApplication} from "../../db/selectors";

const BusinessInfoDisplayName = (): React.ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const {applicationID} = useParams()
  const application = useSelector(selectApplication)

  const [businessDisplayName, setBusinessDisplayName] = useState(application.businessNickname ?? '')

  const isValid = businessDisplayName !== "";

  useEffect(() => {
    // @ts-ignore
    dispatch(gql({
      query: queryApplication,
      variables: {id: applicationID},
      onSuccess: (data) => {
        setBusinessDisplayName(data.application?.businessNickname ?? '')
      }
    }))
  }, [dispatch, applicationID, setBusinessDisplayName]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // @ts-ignore
    dispatch(gql({
      query: updateApplication,
      variables: {
        id: applicationID,
        form: {
          businessNickname: businessDisplayName
        }
      },
      onSuccess: (_) => navigate(`/contractors/${applicationID}/business-info/2`)
    }))
  };

  return (
    <Container>
      <Header
        title="Add Business Info"
        text="The following information will appear in the Freemodel system and help determine which projects are
                right for your business."
      />
      <br/>
      <Text weight="bold">What should your business be called in the Freemodel Directory?</Text>

      <form onSubmit={handleSubmit}>
        <br/>

        <Input
          id="business-display-name"
          label="Business Display Name"
          type="text"
          value={businessDisplayName}
          onChange={e => setBusinessDisplayName(e.target.value)}
          required
        />

        <br/>
        <br/>
        <br/>
        <Button disabled={!isValid}>Continue</Button>
      </form>
    </Container>
  );
};

export default BusinessInfoDisplayName;
